module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Welcome to Admin Settings Page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red",
      "large": ""
    }
  }, [_c('small', {
    staticStyle: {
      "font-size": "9px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lookUp())
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246a1b5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Settings.vue
// module id = 951
// module chunks = 11